<h3>
  <ng-content select="label"></ng-content>
</h3>
@for (item of formArray.controls; track item) {
  @if (itemTemplate) {
    <div #row class="quick-list-row">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
      @if (!readonly && isDeleteReactiveAllowed()) {
        <mad-icon-button data-cy="delete-item-button" (click)="removeReactiveItem(item)">
          <mat-icon>delete</mat-icon>
        </mad-icon-button>
      }
    </div>
  }
}

@if (!readonly) {
  <mad-outline-button data-cy="add-item-button" (click)="addReactiveItem()" [disabled]="!isAddReactiveAllowed()">
    {{ addLabel }}
  </mad-outline-button>
}
